import React, { useState } from 'react';
import { useRouter } from 'next/router';
import ReactGA from 'react-ga4';
import GalleryHero from 'components/GalleryHero';
import getCleverTap from 'utils/clevertap';
import { Box } from '@mui/material';

export default function GalleryHeroContainer() {
  const router = useRouter();
  const { slug } = router.query;
  const pathSegments = router.asPath.split('/');
  const lastSegment = pathSegments[pathSegments.length - 2];
  const [search, setSearch] = useState(slug || lastSegment || '');
  const clevertap = getCleverTap();
  async function handleSearchSubmit() {
    ReactGA.event('Illustration Search');

    clevertap.event.push('Search Input', {
      Product: 'MTG',
      URL: router.asPath,
      Description: 'Illustration Query',
      Locale: 'illustrations',
      Keyword: search,
    });

    router.push(`/illustrations/search/${search}`);
  }

  return (
    <Box bgcolor="#FAFAFA">
      <GalleryHero
        searchValue={search}
        onSearchChange={(value) => setSearch(value)}
        onSearchSubmit={handleSearchSubmit}
      />
    </Box>
  );
}
